import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { AppComponentBase } from '../../app-component-base';
import { FormControl } from '@node_modules/@angular/forms';

@Component({
  selector: 'app-upload-image',
  templateUrl: './upload-image.component.html',
  styleUrl: './upload-image.component.css'
})
export class UploadImageComponent extends AppComponentBase
  implements OnInit {
  _imageUrl: string | ArrayBuffer | null = "/assets/img/avatar-logo.png";
  @Input() imageFormControl: FormControl | null = null;
  @Input() isSubmitForm = false;
  @Input() isDisabled: boolean = false;

  @Input() set imageUrl(v: string | ArrayBuffer | null) {
    if (v) {
      this._imageUrl = v
    }
  };
  @Output() onSelectedImage = new EventEmitter<File>();
  constructor(
    injector: Injector
  ) {
    super(injector);
  }

  onSelectImage(event: any) {
    let selectedFile = event.target.files[0];
    if (selectedFile) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event) => { // called once readAsDataURL is completed
        this._imageUrl = (<FileReader>event.target).result;
        this.onSelectedImage.emit(selectedFile);
        if (this.imageFormControl) {
          this.imageFormControl.setValue(selectedFile);
        }
      }
    }
  }
  ngOnInit(): void {
  }

}
